/*资讯服务-子路由*/
export default [
  {
    path: "/info/gbgk/",
    name: "info_gbgk",
    redirect: "/info/gbgk/gbgk",
    component: resolve =>
      require(["@/components/info/gbgk/index.vue"], resolve),
    meta: {
      title: "场馆简介"
    },
    children: [
      {
        path: "/info/gbgk/gbgk",
        name: "info_gbgk",
        component: resolve =>
          require(["@/components/info/gbgk/gbgk.vue"], resolve),
        meta: {
          title: "场馆简介"
        }
      },
      {
        path: "/info/gbgk/museumintro",
        name: "info_gbgk",
        component: resolve =>
          require(["@/components/info/gbgk/museumintro.vue"], resolve),
        meta: {
          title: "场馆简介"
        }
      },
      {
        path: "/info/gbgk/visitguide",
        name: "info_gbgk",
        component: resolve =>
          require(["@/components/info/gbgk/visitguide.vue"], resolve),
        meta: {
          title: "参观指南"
        }
      },
      // app端
      {
        path: "/info/gbgk/visitguideA",
        name: "info_gbgk",
        component: resolve =>
          require(["@/components/info/gbgk/visitguideA.vue"], resolve),
        meta: {
          title: "参观指南"
        }
      }
    ]
  },
  {
    path: "/info/gbzl",
    name: "info_gbzl",
    redirect: "/info/gbzl/gbzl",
    component: resolve =>
      require(["@/components/info/gbzl/index.vue"], resolve),
    meta: {
      title: "展览列表"
    },
    children: [
      {
        path: "/info/gbzl/gbzl",
        name: "info_gbzl",
        component: resolve =>
          require(["@/components/info/gbzl/gbzl.vue"], resolve),
        meta: {
          title: "展览列表"
        }
      },
      {
        path: "/info/gbzl/list_room/:type",
        name: "info_gbzl",
        component: resolve =>
          require(["@/components/info/gbzl/list_room.vue"], resolve),
        meta: {
          title: "展厅列表"
        }
      },
      {
        path: "/info/gbzl/list_exhibit/:id",
        name: "info_gbzl",
        component: resolve =>
          require(["@/components/info/gbzl/list_exhibit.vue"], resolve),
        meta: {
          title: "展品列表"
        }
      },
      {
        path: "/info/gbzl/detail_room/:id",
        name: "info_gbzl",
        component: resolve =>
          require(["@/components/info/gbzl/detail_room.vue"], resolve),
        meta: {
          title: "展厅详情"
        }
      },
      {
        path: "/info/gbzl/detail/:id",
        name: "info_gbzl",
        component: resolve =>
          require(["@/components/info/gbzl/detail.vue"], resolve),
        meta: {
          title: "展品详情"
        }
      },
      {
        path: "/info/gbzl/search/:keyword",
        name: "info_gbzl",
        component: resolve =>
          require(["@/components/info/gbzl/search.vue"], resolve),
        meta: {
          title: "展品检索结果"
        }
      }
    ]
  },
  {
    path: "/info/wmap",
    name: "info_wmap",
    component: resolve =>
      require(["@/components/info/wmap/index.vue"], resolve),
    meta: {
      title: "微地图"
    },
    children: [
      {
        path: "/info/wmap/map/:type/:floor",
        name: "info_wmap",
        component: resolve =>
          require(["@/components/info/wmap/map.vue"], resolve),
        meta: {
          title: "微地图"
        }
      },
    ]
  },
  
];


// WEBPACK FOOTER //
// ./src/router/info/index.js